import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function AuthSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (token) {
      localStorage.setItem("vouch_token", token);
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-success">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-[#FF4F00] animate-spin mx-auto mb-4" />
        <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500">
          Signing you in…
        </div>
      </div>
    </div>
  );
}
